import { useMemo } from 'react';
import { getBridge } from '@/platform';

/** Доступ к тактильному отклику платформы без прямого обращения к SDK. */
export function useHaptic() {
  return useMemo(() => getBridge().haptic, []);
}
